import React from 'react';

const Figma = ({cls}) => {
    return (
        <svg
        className={cls}
        xmlns="http://www.w3.org/2000/svg"
        enableBackground="new 0 0 512 512"
        viewBox="0 0 512 512"
    >
        <g xmlns="http://www.w3.org/2000/svg">
            <path
                fill="#00bcff"
                d="M256.599 256c0-47.128 38.205-85.333 85.333-85.333s85.333 38.206 85.333 85.333c0 47.129-38.206 85.333-85.333 85.333-47.129 0-85.333-38.205-85.333-85.333z"
                data-original="#00bcff"
            ></path>
            <path
                fill="#00cf7f"
                d="M85.932 426.667c0-47.128 38.205-85.333 85.333-85.333l45.475-24.009 39.858 24.009v85.333c0 47.129-38.205 85.333-85.333 85.333s-85.333-38.205-85.333-85.333z"
                data-original="#00cf7f"
            ></path>
            <path
                fill="#ff7361"
                d="M256.599 0l-46.434 80.67 46.434 89.996h84.136c47.129 0 85.333-38.205 85.333-85.333S387.863 0 340.735 0z"
                data-original="#ff7361"
            ></path>
            <path
                fill="#ff4d12"
                d="M84.734 85.333c0 47.128 38.205 85.333 85.333 85.333l45.267 17.484 41.263-17.484V0h-86.531c-47.127 0-85.332 38.205-85.332 85.333z"
                data-original="#ff4d12"
            ></path>
            <path
                fill="#b659ff"
                d="M85.932 256c0 47.129 38.205 85.333 85.333 85.333h85.333V170.666h-85.333c-47.128 0-85.333 38.206-85.333 85.334z"
                data-original="#b659ff"
            ></path>
        </g>
    </svg>
    );
}

export default Figma;
